import baseAPI from '@/api/base';
import { EditEmployeePayrollComponent, GetEmployeePayrollComponent, RegisterEmployeePayrollComponent } from '@/dtos/employee_payroll_component.dto';
import {
  DELETE_EMPLOYEE_PAYROLL_COMPONENT_URL,
  EDIT_EMPLOYEE_PAYROLL_COMPONENT_URL,
  GET_EMPLOYEE_PAYROLL_COMPONENT_URL,
  REGISTER_EMPLOYEE_PAYROLL_COMPONENT_URL,
  TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeePayrollComponent {
  static getEmployeePayrollComponents = async (getEmployeePayrollComponent: GetEmployeePayrollComponent): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_PAYROLL_COMPONENT_URL, {
      params: getEmployeePayrollComponent,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeePayrollComponent = async (
    registerEmployeePayrollComponent: RegisterEmployeePayrollComponent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_PAYROLL_COMPONENT_URL, {
      ...registerEmployeePayrollComponent,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeePayrollComponent = async (editEmployeePayrollComponent: EditEmployeePayrollComponent): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_PAYROLL_COMPONENT_URL, {
      ...editEmployeePayrollComponent,
    });
    return response;
  };

  static toggleEmployeePayrollComponentIsActive = async (
    editEmployeePayrollComponent: EditEmployeePayrollComponent
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE_URL,
      {
        ...editEmployeePayrollComponent,
      }
    );
    return response;
  };

  static deleteEmployeePayrollComponent = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_PAYROLL_COMPONENT_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeePayrollComponent;
